export const teamsStoreKey = 'teams';
